import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Postulante } from '../models/Postulante';
import { Observable} from 'rxjs';
import { map} from 'rxjs/operators';
import { URL_API} from '../global/config';

@Injectable({
  providedIn: 'root'
})
export class PostulanteService {

  private urlEndpoint: string = URL_API.UrlApi+'/api/v1/postulantes';
  private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'})

constructor(
  private http: HttpClient
) { }

  //traer o Listar a todos los Postulantes
  getPostulantes(): Observable<Postulante[]>{
    return this.http.get(this.urlEndpoint).pipe(
      map( (response) => response as Postulante[])
    )
  }

  //traer a un Postulante por el ID
  traerPostulante(id: Number): Observable<Postulante>{
    return this.http.get<Postulante>(`${this.urlEndpoint}/${id}`)
  };

  //crear o guardar Postulante
  crearPostulante(postulante: Postulante): Observable<Postulante>{
    return this.http.post<Postulante>(this.urlEndpoint, postulante, { headers: this.httpHeaders});

  }

  //actualizar el Objeto Postulante
  actualizarPostulante(postulante: Postulante): Observable<Postulante>{
    return this.http.put<Postulante>(`${this.urlEndpoint}/${postulante.id}`, postulante, { headers: this.httpHeaders})
  }

}
